<template>
  <div id="orderItemBaseView">
    <el-card class="box-card">
      <el-row class="order_product_table">
        <el-row>
          <span class="label">工单号：</span>
          <span class="value" style="width:210px">{{ baseData.productionBatchCode ? baseData.productionBatchCode : "&nbsp;" }} </span>

          <span class="label" v-if="baseData.childProductionBatchCode">子工单号：</span>
          <span class="value" v-if="baseData.childProductionBatchCode">{{ baseData.childProductionBatchCode }} </span>

          <span class="label">订单号：</span>
          <span class="value" style="width:190px">{{ baseData.orderCode ? baseData.orderCode : "&nbsp;" }}</span>

          <span class="label">工单状态：</span>
          <span class="value">{{ baseData.splitStatus | parseStatus }} </span>
        </el-row>
        <el-row>
          <span class="label">物料编码：</span>
          <span class="value">{{ showMaterialCode ? showMaterialCode : "&nbsp;" }}</span>

          <span class="label">物料名称：</span>
          <span class="value">{{ showMaterialName ? showMaterialName : "&nbsp;" }}</span>

          <span class="label">物料类型：</span>
          <span class="value">{{ showMaterialType ? showMaterialType : "&nbsp;" }}</span>

          <span class="label">生产数量：</span>
          <span class="value">{{ splitCount ? splitCount : "&nbsp;" }} {{ baseData.unitType }}</span>

          <!-- <span class="label" v-if='permission.btn_pickMaterial_lookPickMaterial'>领料进度：</span>
                    <span class="y_lookValue" v-if='permission.btn_pickMaterial_lookPickMaterial' @click="MaterialDialogClick()">查看</span> -->
        </el-row>
        <el-row>
          <span class="label">计划开始时间：</span>
          <span class="value" style="width:176px">{{ baseData.startTime | showSubmitTime(true) }}</span>
          <span class="label">计划完工时间：</span>
          <span class="value">{{ baseData.planningEndTime | showSubmitTime(true) }}</span>
        </el-row>

        <el-row>
          <el-table class="progress_table" maxHeight="461" :cell-style="cellStyle" :cell-class-name="showCellClass" :data="progressData" tooltip-effect="dark" :span-method="objectSpanMethod" border>
            <el-table-column label="序号" width="46" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{ scope.row.index }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="procedureName" label="工序名称" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="planTime" label="计划生产时间" min-width="188" show-overflow-tooltip></el-table-column>
            <el-table-column prop="actualStartTime" label="实际开始时间" min-width="100" show-overflow-tooltip :formatter="$commonUtil.changeToDate"></el-table-column>
            <el-table-column prop="actualEndTime" label="实际结束时间" min-width="100" show-overflow-tooltip :formatter="$commonUtil.changeToDate"></el-table-column>
            <el-table-column prop="factoryModelName" label="机组" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="deviceCode" label="编排设备" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="scanDeviceCode" label="扫码设备" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="workerName" label="执行者" min-width="80" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="productionEfficiency" label="实际节拍(s)" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="unqualifiedProcessCount" label="不合格数量" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="spoiledProcessCount" label="报废数量" min-width="70" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qualifiedProcessCount" label="完成数量" min-width="70" show-overflow-tooltip></el-table-column>
            <el-table-column prop="actualFinishedAmount" label="实际数量" width="90">
              <template slot-scope="scope">
                <el-tooltip :content="'' + scope.row.actualFinishedAmount" placement="top">
                  <span style="position: relative;top: 4px;margin-right:0px;width: 41px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;display: inline-block;">{{
                    scope.row.actualFinishedAmount
                  }}</span>
                </el-tooltip>
                <el-button
                  v-if="permission.btn_productionPlan_updateActualFinishedAmount"
                  icon="el-icon-edit"
                  @click="showUpdataCount(scope.row)"
                  style="position: relative;top: 6px;padding:4px;margin:none;border:none;vertical-align: top;"
                ></el-button>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="70" show-overflow-tooltip></el-table-column>
            <el-table-column prop="progress" label="进度" min-width="80" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-progress :text-inside="true" :stroke-width="18" :color="scope.row.color" :percentage="scope.row.progress"></el-progress>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-row>

      <el-dialog title="修改数量" center :visible.sync="isShowDialog" width="30%" :close-on-click-modal="false">
        <div style="margin-top:-14px;margin-bottom:26px">
          <el-form ref="form" :model="form" :rules="rules">
            <el-table :data="dataList" stripe>
              <el-table-column label="报工时间" min-width="100" prop="submitTime">
                <template slot-scope="scope">
                  <el-form-item>
                    <span>{{ scope.row.submitTime | showSubmitTime }}</span>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="报工数量" prop="submitAmount" min-width="100">
                <template slot-scope="scope">
                  <el-form-item>
                    <span>{{ scope.row.submitAmount }}</span>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="实际数量" prop="actualAmount" min-width="100">
                <template slot-scope="scope">
                  <el-form-item :prop="`dataList[${scope.$index}].actualAmount`" :rules="rules.actualAmount">
                    <el-input v-model="scope.row.actualAmount" :maxlength="9" style="width:80px"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button size="small" @click="isShowDialog = false" style="margin-left: 20px;">取 消</el-button>
          <el-button type="primary" size="small" @click="updataCount">确 定</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import commom from "@/util/CommonUtils";
export default {
  name: "OrderItemBaseView",
  props: {
    baseData: Object
  },
  data() {
    return {
      rules: {
        actualAmount: [
          { required: true, message: "请输入完成数量", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (Number(value) >= 0) {
                callback();
              } else {
                callback(new Error("数量不能小于零"));
              }
            },
            trigger: "blur"
          }
        ]
      },
      MaterialData: [],
      MaterialDialogVisible: false,
      dataList: [],
      isShowDialog: false,
      errList: [],
      form: {
        dataList: [],
        planId: null
      },
      clickLooklist: [],
      pickList: [],
      pickMaterialsList: [],
      clickLookForm: {
        splitId: null,
        materialName: "",
        materialCode: "",
        specification: "",
        unitType: ""
      },
      planId: null,
      activeName: "0",
      splitCount: null,
      productionType: 0,
      planedProductionPlanList: null, //生成计划预安排
      productionNum: 0,
      progressData: [],
      progress: 0,
      permission: JSON.parse(localStorage.getItem("permission"))
    };
  },
  //el和data尚未初始化
  beforeCreate: function() {},
  //data初始化完成
  created: function() {},
  //el初始化完成
  beforeMount: function() {},
  //完成挂载
  mounted: function() {
    this.parseInitData();
  },
  //更新dom时触发
  beforeUpdate: function() {},
  updated: function() {},
  activated: function() {},
  deactivated: function() {},
  beforeDestroy: function() {},
  destroyed: function() {},
  components: {},
  computed: {
    showMaterialName() {
      let data = this.baseData;
      return data.materialName || "";
    },

    showMaterialCode() {
      let data = this.baseData;
      return data.materialCode || "";
    },

    showMaterialModel() {
      let data = this.baseData;
      return data.specification || "";
    },

    showMaterialType() {
      let data = this.baseData;
      let str = "";
      if (data != null) {
        if (data.itemType == 1) {
          str = "零件";
        } else {
          str = "产品";
        }
      }
      return str;
    }
  },
  methods: {
    parsePlanTime(rowData) {
      planningEndTime;
    },
    parseInitData() {
      let arr = [];
      this.splitCount = this.baseData.needAmount;
      this.baseData.dataList.forEach((item, itemIndex) => {
        if (item.startTime) {
          item.startTime = commonUtils.timestampToDate(item.startTime).slice(0, 13) + "时";
        } else {
          item.startTime = "";
        }
        if (item.planningEndTime) {
          item.planningEndTime = commom.timestampToDate(item.planningEndTime).slice(0, 13) + "时";
        } else {
          item.planningEndTime = "";
        }
        if (item.startTime || item.planningEndTime) {
          item.planTime = item.startTime + "—" + item.planningEndTime;
        } else {
          item.planTime = "";
        }

        this.parseProgress(item, item.productionCount);
        if (item.technologyFileName) {
          item.filePath = this.getFilePath(item.technologyFileName);
        }

        if (!item.workerName) {
          item.workerName = "";
        }

        if (item.processList.length > 1) {
          let allCount = 0;
          item.processList.forEach(s => {
            allCount += s.actualFinishedAmount + s.unqualifiedProcessCount;
          });
          item.planIds = item.processList.map(p => p.planId);

          item.processList.forEach((subItem, index) => {
            if (index == 0) {
              subItem.len = item.processList.length;
            }
            subItem.subPlanId = item.planId;
            subItem.index = itemIndex + 1;
            subItem.planningEndTime = item.planningEndTime;
            subItem.startTime = item.startTime;
            subItem.technologyFileId = item.technologyFileId;
            subItem.technologyFileName = item.technologyFileName;
            subItem.technologyFileUrl = item.technologyFileUrl;
            subItem.amountOfPollingTask = item.amountOfPollingTask;
            // subItem.productionEfficiency = item.productionEfficiency
            // subItem.isError = item.isError
            subItem.procedureIndex = item.procedureIndex;
            subItem.procedureName = item.procedureName;
            subItem.productionCount = item.productionCount;
            subItem.filePath = item.filePath;
            // subItem.groupName=item.groupName
            subItem.planTime = item.planTime;
            subItem.planIds = item.planIds;
            subItem.qualifiedProcessCount = item.qualifiedProcessCount;
            this.parseProgress(subItem, item.productionCount, allCount);
            arr.push(subItem);
          });
        } else {
          item.planIds = (item.processList || []).map(p => p.planId);
          item.len = 1;
          item.index = itemIndex + 1;
          item.workerName = item.processList[0].workerName;
          item.deviceCode = item.processList[0].deviceCode;
          item.scanDeviceCode = item.processList[0].scanDeviceCode;
          item.remark = item.processList[0].remark;
          item.groupName = item.processList[0].groupName;
          item.productionEfficiency = item.processList[0].productionEfficiency;
          item.isError = item.processList[0].isError;
          item.actualStartTime = item.processList[0].actualStartTime;
          item.actualEndTime = item.processList[0].actualEndTime;
          item.actualFinishedAmount = item.processList[0].actualFinishedAmount;
          item.unqualifiedProcessCount = item.processList[0].unqualifiedProcessCount;
          item.qualifiedProcessCount = item.qualifiedProcessCount;
          item.subPlanId = item.processList[0].planId;
          item.spoiledProcessCount = item.processList[0].spoiledProcessCount;
          this.parseProgress(item, item.productionCount, item.actualFinishedAmount + item.unqualifiedProcessCount);
          arr.push(item);
        }
      });

      this.progressData = arr;
      this.planId = (arr[0] || {}).planId;
    },
    async showUpdataCount(rowData) {
      if (rowData.productionType == 2 || rowData.productionType == 4) {
        this.form.planId = rowData.planId;
      } else {
        this.form.planId = rowData.subPlanId;
      }
      let {
        data: { dataList },
        code,
        msg,
        message
      } = await this.$RequestUtil.getAsync({ url: "/api/productionPlan/listSubmit", type: "sync", params: { planId: this.form.planId } });
      if (code == 0) {
        this.dataList = dataList;
        this.form.dataList = dataList;
        this.isShowDialog = true;
      } else {
        this.$message.error(message || msg);
      }
    },

    updataCount() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          let dataList = this.dataList.map(item => {
            return { id: item.id, actualAmount: item.actualAmount };
          });
          this.$RequestUtil.post({
            url: "/api/productionPlan/updateActualFinishedAmount",
            type: "sync",
            params: {
              planId: this.form.planId,
              dataList
            },
            success: res => {
              if (res.code == 0) {
                this.$message.success("修改成功");
                this.loadPartData(this.baseData.splitId);
                this.isShowDialog = false;
              } else {
                this.$message.error(res.message || res.msg);
              }
            }
          });
        }
      });
    },

    handleClick(ev) {
      if (this.activeName == 1) {
        this.loadErrReport();
      }
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 3 || columnIndex == 15) {
        if (row.len) {
          return {
            rowspan: row.len,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },

    /**
     * 根据返回的isError 来判断是非高亮显示
     */
    showCellClass({ row, column, rowIndex, columnIndex }) {
      if (row.isError) {
        if (columnIndex > 7 && columnIndex < 14) {
          return "show-highlight";
        }
      }
    },

    getFilePath(fileName) {
      if (!fileName) {
        return;
      }
      let filePath = "";
      let arr = fileName.split(".");
      let suffix = arr[arr.length - 1];
      switch (true) {
        case suffix == "pdf" || suffix == "pptx":
          filePath = "../../static/img/pdf.png";
          break;
        case suffix == "png" || suffix == "jpg" || suffix == "svg":
          filePath = "../../static/img/pic.png";
          break;
        case suffix == "txt" || suffix == "doc" || suffix == "docx":
          filePath = "../../static/img/txt.png";
          break;

        default:
          filePath = "../../static/img/file.png";
      }
      return filePath;
    },

    showFile: function(url) {
      if (!this.permission.btn_file_get) {
        this.$message({
          type: "error",
          message: `抱歉，您暂无文件读取权限`
        });
        return false;
      }
      if (!url) {
        this.$message.warning("当前文件不存在");
        return;
      }
      let index = url.lastIndexOf(".");
      let ext = url.substr(index + 1).toLowerCase();
      //可直接被浏览器打开的文件类型
      let arr = ["pdf", "png", "jpg", "svg", "txt", "html", "js", "art", "au", "aiff", "xbf", "jpeg"];
      if (arr.includes(ext)) {
        window.open(url, "_blank");
      } else {
        window.location.href = url;
      }
    },

    /**
		 * @description: 
		 * @param {type} 
		 * @return {type} 
		 * 1.扫码设备存在
			1.1) 编排任务设备存在  
				a. 设备一致     显示扫码设备 绿色
				b. 设备不一致   显示扫码设备  红色
			1.2)编排任务设备不存在
				显示扫码设备  颜色黄色

			2.扫码设备不存在
				2.1) 编排任务设备存在  显示编排任务设备 颜色无
				2.2)编排任务设备不存在  空  
		*/

    parseDevice(row) {
      let deviceCode = "";
      if (row.scanDeviceCode) {
        deviceCode = row.scanDeviceCode;
      } else {
        deviceCode = row.deviceCode;
      }
      return deviceCode;
    },

    cellStyle({ row, column, rowIndex, columnIndex }) {
      let style = {};
      if (row.scanDeviceCode) {
        if (row.deviceCode) {
          if (row.deviceCode == row.scanDeviceCode) {
            style = { background: "green", color: "#fff" };
          } else {
            style = { background: "red", color: "#fff" };
          }
        } else {
          style = { background: "yellow", color: "#fff" };
        }
      }
      if (column.label == "设备编号") {
        return style;
      }
    },

    loadPartData(splitItemId) {
      this.$RequestUtil.get({
        url: "/api/productionPlan/listPartProcessByPartPlan",
        type: "sync",
        params: {
          splitItemId
        },
        success: res => {
          let arr = [];
          res.data.forEach((item, itemIndex) => {
            if (item.startTime) {
              item.startTime = commonUtils.timestampToDate(item.startTime).slice(0, 13) + "时";
            } else {
              item.startTime = "";
            }
            if (item.planningEndTime) {
              item.planningEndTime = commom.timestampToDate(item.planningEndTime).slice(0, 13) + "时";
            } else {
              item.planningEndTime;
            }
            if (item.planningEndTime || item.startTime) {
              item.planTime = item.startTime + "—" + item.planningEndTime;
            } else {
              item.planTime = "";
            }

            this.parseProgress(item, item.productionCount);
            if (item.technologyFileName) {
              item.filePath = this.getFilePath(item.technologyFileName);
            }

            if (!item.workerName) {
              item.workerName = "";
            }

            // if(this.baseData.productionType == 1||this.baseData.productionType == 0){
            if (item.processList.length > 1) {
              let allCount = 0;
              item.processList.forEach(s => {
                allCount += s.actualFinishedAmount + s.unqualifiedProcessCount;
              });
              item.planIds = item.processList.map(p => p.planId);

              item.processList.forEach((subItem, index) => {
                if (index == 0) {
                  subItem.len = item.processList.length;
                }
                subItem.subPlanId = subItem.planId;
                subItem.index = itemIndex + 1;
                subItem.planningEndTime = item.planningEndTime;
                subItem.startTime = item.startTime;
                subItem.technologyFileId = item.technologyFileId;
                subItem.technologyFileName = item.technologyFileName;
                subItem.technologyFileUrl = item.technologyFileUrl;
                subItem.amountOfPollingTask = item.amountOfPollingTask;
                // subItem.productionEfficiency = item.productionEfficiency
                // subItem.isError = item.isError
                subItem.procedureIndex = item.procedureIndex;
                subItem.procedureName = item.procedureName;
                subItem.productionCount = item.productionCount;
                subItem.filePath = item.filePath;
                // subItem.groupName=item.groupName
                subItem.planTime = item.planTime;
                subItem.planIds = item.planIds;

                this.parseProgress(subItem, item.productionCount, allCount);
                arr.push(subItem);
              });
            } else {
              item.planIds = item.processList.map(p => p.planId);
              item.len = 1;
              item.index = itemIndex + 1;
              item.workerName = item.processList[0].workerName;
              item.deviceCode = item.processList[0].deviceCode;
              item.scanDeviceCode = item.processList[0].scanDeviceCode;
              item.remark = item.processList[0].remark;
              item.groupName = item.processList[0].groupName;
              item.productionEfficiency = item.processList[0].productionEfficiency;
              item.isError = item.processList[0].isError;
              item.actualStartTime = item.processList[0].actualStartTime;
              item.actualEndTime = item.processList[0].actualEndTime;
              item.actualFinishedAmount = item.processList[0].actualFinishedAmount;
              item.unqualifiedProcessCount = item.processList[0].unqualifiedProcessCount;
              item.qualifiedProcessCount = item.processList[0].qualifiedProcessCount;
              item.subPlanId = item.processList[0].planId;
              item.spoiledProcessCount = item.processList[0].spoiledProcessCount;
              this.parseProgress(item, item.productionCount, item.actualFinishedAmount + item.unqualifiedProcessCount);
              arr.push(item);
            }

            // }
          });

          // if(this.baseData.productionType == 1||this.baseData.productionType == 0){
          this.progressData = arr;
          this.planId = arr[0].planId;
          // }else{
          //     this.progressData = res.data
          // }
        }
      });
    },

    backToOrderItemView() {
      this.$parent.reload(this.baseData.page);
      this.$parent.showPage = 1;
    },

    parseProgress(item, productionCount, allCount) {
      productionCount = this.splitCount || productionCount;
      if (allCount) {
        item.progress = Math.floor((allCount / productionCount) * 100);
      } else {
        item.progress = Math.floor(((item.actualFinishedAmount + item.unqualifiedProcessCount) / productionCount) * 100);
      }
      if (item.progress > 100) {
        item.progress = 100;
      }
      // if(item.planState==2){
      //     item.color = 'rgb(255,86,34)'
      // }else{

      // }
      if (item.progress == 0) {
        item.color = "rgb(244,246,245)";
      } else if (item.progress > 0 && item.progress < 100) {
        item.color = "rgb(255,186,1)";
      } else if (item.progress == 100) {
        item.color = "rgb(108,213,137)";
      }
    },

    parseTime: function(rowData) {
      if (rowData.time != null) {
        let dateString = commonUtils.timestampToDate(rowData.time, false);
        return dateString;
      }
    }
  },
  watch: {},
  filters: {
    showSubmitTime(ev, show) {
      return commonUtils.timestampToDate(ev, show);
    },
    parseStatus(ev) {
      let orderStatusOptions = [
        // 0-未排产 1-已排产 2-已派工 3-生产中 4-已完成
        { id: 0, label: "未排产", value: 0 },
        { id: 1, label: "已排产", value: 1 },
        { id: 2, label: "已派工", value: 2 },
        { id: 3, label: "生产中", value: 3 },
        { id: 4, label: "已完成", value: 4 },
        { id: 5, label: "已关闭", value: 5 }
      ];
      if (ev != null && ev != undefined) {
        return (orderStatusOptions.find(item => item.value == ev) || {}).label;
      }
    }
  }
};
</script>

<style scoped>
#orderItemBaseView {
  /* padding-bottom: 10px; */
  margin-bottom: 10px;
}

/* .order_product_table{
      width: 98%
  } */
.file-icon-container {
  width: 36px;
  height: 45px;
  margin-top: 0px;

  background-size: cover;
  position: relative;
  cursor: pointer;
}

.order_item_title {
  margin-top: 10px;
  font-size: 22px;
}

.margin_left_15 {
  margin-left: 15px;
  padding: 8px 0;
}

.operateBtn-wrap {
  margin-top: 0px;
}

.label {
  display: inline-block;

  height: 32px;
  line-height: 32px;
  font-size: 12px;
  color: #606266;
}

.value {
  display: inline-block;
  width: 200px;
  /* height: 32px; */
  line-height: 32px;
  font-size: 12px;
  color: #606266;
  vertical-align: top;
}

@media screen and (min-width: 1280px) and (max-width: 1366px) {
  .value {
    width: 150px !important;
  }
}

.progress_table {
}
.y_lookValue {
  font-size: 12px;
  color: #409eff;
  cursor: pointer;
}
</style>

<style>
/* .order_product_table .progress_table .el-table__body-wrapper {
        max-height: 250px !important;
        overflow-y: auto !important;
    }
    @media screen and (min-width:1441px) {
        .order_product_table .progress_table .el-table__body-wrapper {
            max-height:400px !important ;
            overflow-y:auto !important ;
            
        }
    } */

/* @media screen and (max-width: 1440px) and (min-width: 1367px) {
    .order_product_table .progress_table .el-table__body-wrapper {
      max-height: 350px !important;
      overflow-y: auto !important;
    }
  }

  @media screen and (max-width: 1366px) {
    .order_product_table .progress_table .el-table__body-wrapper {
      max-height: 300px !important;
      overflow-y: auto !important;
    }
  } */
#orderItemBaseView .el-form-item--mini.el-form-item,
#orderItemBaseView .el-form-item--small.el-form-item {
  margin-bottom: 14px;
  margin-top: 2px;
}

.show-highlight {
  background: #ffffcc;
}

.y_flex {
  display: flex;
}

.y_flex span:nth-child(1) {
  width: 80px;
  height: 30px;
  display: inline-block;
  line-height: 30px;
  text-align: right;
  align-self: center;
}

.y_flex span:nth-child(2) {
  flex: 1;
  align-self: center;
  height: 30px;
  line-height: 30px;
  display: inline-block;
  font-size: 12px;
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/views/order/SalesOrder/OrderItemBaseView.vue